import { Box } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import './Reactions.module.css';

type ReactionsPopoverButtonPropTypes = {
  isClicked: boolean;
  theme: 'light' | 'dark';
};

export const ReactionsPopoverButton = ({
  isClicked = false,
  theme,
}: ReactionsPopoverButtonPropTypes) => {
  const { backgroundColor, borderColor, iconColor } = getColorConfig({
    theme,
    isClicked,
  });

  const hoverBorderColor =
    theme === 'dark' ? 'var(--white)' : 'var(--fgInteractive)';

  return (
    <Box
      bg={backgroundColor}
      borderRadius="var(--border-radius12)"
      border={`1px solid ${borderColor}`}
      cursor="pointer"
      _hover={{
        border: `1px solid ${hoverBorderColor}`,
      }}
    >
      <Spacer size="sm">
        <Spacer size="zr xsm">
          <Icon
            stroke={iconColor}
            width="16px"
            height="16px"
            name={iconNames.reaction}
          />
        </Spacer>
      </Spacer>
    </Box>
  );
};

const getColorConfig = ({
  theme,
  isClicked,
}: {
  theme: 'light' | 'dark';
  isClicked: boolean;
}) => {
  switch (theme) {
    case 'dark':
      return {
        backgroundColor: isClicked
          ? 'transparent'
          : 'var(--bgCompSecondaryTiny)',
        borderColor: isClicked ? 'var(--white)' : 'transparent',
        iconColor: isClicked ? 'var(--fgInteractive)' : 'var(--white)',
      };
    case 'light':
    default:
      return {
        backgroundColor: isClicked
          ? 'transparent'
          : 'var(--bgCompSecondaryTiny)',
        borderColor: isClicked ? 'var(--fgInteractive)' : 'transparent',
        iconColor: isClicked ? 'var(--fgInteractive)' : 'var(--black)',
      };
  }
};
